/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * Zuordnung eines Datensatzes zu einem Datensatz der HAUPTdatenbank.
 * BESONDERHEIT: Dieses Feld schreibt NICHT in `fieldsValues` wie alle uebrigen, sondern setzt `belongsTo` am Eintrag selbst — denselben Bezug, den die Master-Detail-Ansicht beim Einstieg ueber die Hauptdatenbank herstellt. Es macht diesen Bezug lediglich auch dann setzbar, wenn man direkt in der Unterdatenbank arbeitet.
 * Die Zuordnung ist freiwillig: Ein Datensatz ohne `belongsTo` bleibt bestehen und ist beim direkten Einstieg sichtbar — nur ueber die Hauptdatenbank taucht er nicht auf.
 * @export
 * @interface DatabaseParentEntryField
 */
export interface DatabaseParentEntryField extends DatabaseField {
    /**
     * Welches Feld der Hauptdatenbank die Auswahl beschriftet. Ohne Angabe dienen deren Vorschaufelder als Rueckfall — sonst stuende in der Liste nichts als die Kennung.
     * @type {string}
     * @memberof DatabaseParentEntryField
     */
    labelFieldId?: string;
}

/**
 * Check if a given object implements the DatabaseParentEntryField interface.
 */
export function instanceOfDatabaseParentEntryField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseParentEntryFieldFromJSON(json: any): DatabaseParentEntryField {
    return DatabaseParentEntryFieldFromJSONTyped(json, false);
}

export function DatabaseParentEntryFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseParentEntryField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'labelFieldId': !exists(json, 'labelFieldId') ? undefined : json['labelFieldId'],
    };
}

export function DatabaseParentEntryFieldToJSON(value?: DatabaseParentEntryField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'labelFieldId': value.labelFieldId,
    };
}

